import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';
import ActionsList from 'mutation/components/registration-civil-union/resident/actions-list';
import { SearchPersonCivilUnionCrumbs } from 'mutation/constants/registration-cancel-civil-union-crumbs';

const SearchPersonsPageCivilUnion = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={SearchPersonCivilUnionCrumbs} />
      <PersonSearch
        pathname="/mutazioni/cerca-persona/unione-civile/scioglimento"
        action={ActionsList}
        addedTitle={'- Annullamento Unione Civile'}
      />
    </Fragment>
  );
};

SearchPersonsPageCivilUnion.displayName = 'Persons page component';

export default SearchPersonsPageCivilUnion;
